import { render, staticRenderFns } from "./LayoutEmpty.vue?vue&type=template&id=1f5ca536&scoped=true"
import script from "./LayoutEmpty.vue?vue&type=script&lang=js"
export * from "./LayoutEmpty.vue?vue&type=script&lang=js"
import style0 from "./LayoutEmpty.vue?vue&type=style&index=0&id=1f5ca536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5ca536",
  null
  
)

export default component.exports